module.exports = __webpack_public_path__ + "img/06.a60725b2.png";